import { render, staticRenderFns } from "./MobileMenuLinks.vue?vue&type=template&id=2a5ef4dc&scoped=true"
import script from "./MobileMenuLinks.vue?vue&type=script&lang=ts"
export * from "./MobileMenuLinks.vue?vue&type=script&lang=ts"
import style0 from "./MobileMenuLinks.vue?vue&type=style&index=0&id=2a5ef4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5ef4dc",
  null
  
)

export default component.exports